export function initPopups() {

	const body = document.body;

	let popups = document.querySelectorAll('.popup');


	let openPopup = function (e) {
		e.preventDefault();

		let popupID = this.dataset.popup;
		let popup = document.getElementById(popupID);

		if (popup !== null)
		{
			// close other open popups
			let openPopups = document.querySelectorAll('.popup.popup--active');
			openPopups.forEach((el) => {
				let popup = document.getElementById(el.id);

				if (popup !== null)
				{
					popup.classList.remove('popup--active');
					body.classList.remove('popup-open');
				}
			});

			popup.classList.add('popup--active');

			body.classList.add('popup-open');
		}

		return false;
	};


	let closePopup = function (e) {
		let popupID;

		if (this.classList.contains('popup'))
		{
			let container = this.querySelector('.popup__content');

			// if the target of the click isn't the container nor a descendant of the container
			if (!container.isEqualNode(e.target) && !container.contains(e.target))
			{
				popupID = this.id;
			}
		}

		if (this.classList.contains('popup__close'))
		{
			popupID = this.closest('.popup').id;
		}

		if (popupID === null)
		{
			return false;
		}

		let popup = document.getElementById(popupID);

		if (popup !== null)
		{
			popup.classList.remove('popup--active');
			body.classList.remove('popup-open');
		}

		return false;
	};


	const openPopupLinks = document.querySelectorAll('.open-popup');

	openPopupLinks.forEach((el) => {

		el.removeEventListener('click', openPopup);
		el.addEventListener('click', openPopup);

	});


	// Close popup when the user clicks outside the popup
	popups.forEach((el) => {

		if (!el.classList.contains('popup--fullscreen'))
		{
			el.removeEventListener('click', closePopup);
			el.addEventListener('click', closePopup);
		}

	});


	// Close popup when the user clicks the close button
	document.querySelectorAll('.popup__close, .close-popup').forEach((el) => {

		el.removeEventListener('click', closePopup);
		el.addEventListener('click', closePopup);

	});

}

export function closePopupById(popupID) {
	let popup = document.getElementById(popupID);

	if (popup !== null)
	{
		popup.classList.remove('popup--active');
		document.body.classList.remove('popup-open');
	}

	return false;
}